import { plainToInstance, Type } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import { IRegisterInspection } from '@core/entities/register/RegisterInspection'
import { User } from '@core/entities/user'
import { Checklist } from '@core/entities/checklist/Checklist'
import moment from 'moment'

export class RegisterInspection extends Entity<IRegisterInspection> {
  completedRuns: number

  registerTemplateInspectionId: string

  lastInspectionTime: string

  nextInspectionDue: string

  checklistTemplates?: Array<{
    id: number
    name: string
  }>

  @Type(() => User)
  lastInspectedBy: User

  @Type(() => Checklist)
  lastSubmittedChecklist: Checklist

  openTasks?: number

  public static new(payload: unknown): RegisterInspection {
    const entity = plainToInstance(RegisterInspection, payload)

    return entity
  }

  public isOverdue(): boolean {
    if (!this.nextInspectionDue) return false
    const now = moment()
    const due = moment(this.nextInspectionDue)
    return now.isAfter(due)
  }

  public static getDueDateColor(
    dueDate: string | undefined,
  ): string | undefined {
    if (!dueDate) return undefined
    const now = moment()
    const due = moment(dueDate)

    if (now.isAfter(due)) return 'error.main'
    if (due.diff(now, 'days') < 2) return 'warning.main'
    return undefined
  }
}
